interface ServicesConfig {
    [key: string]: string | (() => string)
}

interface HeadersConfig {
    [key: string]: string | (() => string | null)
}

type AppName = 'Infix' | 'Story' | 'Survey'

const Connection = (function () {
    const errorMessage =
        'Connection config not set, please call config(services, headers)'

    // Declare variables for service headers and services
    let ServiceHeaders: HeadersConfig
    let Services: ServicesConfig | null = null
    let AppType: AppName = 'Infix'

    // Config function to set headers and services
    const config = (
        services: ServicesConfig,
        headers: HeadersConfig,
        appType: AppName
    ): void => {
        ServiceHeaders = headers
        Services = services
        AppType = appType
    }

    const getAppType = (): AppName => {
        return AppType
    }

    // Function to handle response content
    const content = (response: Response): Promise<any> => {
        if (response.status === 204) {
            return Promise.resolve({})
        }
        return response.json()
    }

    // Function to handle errors in the response
    const errored = (response: Response): Response => {
        if (!response.ok) {
            throw new Error(response.statusText)
        }
        return response
    }

    const headers = (): HeadersInit => {
        if (!ServiceHeaders) {
            throw new Error(errorMessage)
        }

        const transformedHeaders: Record<string, string> = {}

        // Ensure ServiceHeaders is of type HeadersConfig before iterating over it
        Object.keys(ServiceHeaders).forEach((key) => {
            const headerValue = ServiceHeaders[key as keyof HeadersConfig] // Explicitly assert key as a valid key of HeadersConfig

            const val: string | null =
                typeof headerValue === 'function' ? headerValue() : headerValue

            if (val !== null) {
                transformedHeaders[key] = val // Assign the value only if it's not null
            }
        })

        return transformedHeaders
    }

    // Function to get the base URL for a given service
    const baseUrl = (service: string): string => {
        if (!Services) {
            throw new Error(errorMessage)
        }
        if (!service) {
            throw new Error('parameter is null')
        }

        const BaseUrl = Services[service]
        if (!BaseUrl) {
            throw new Error(`'${service}' not found in service list`)
        }

        // Allow function-based base URLs
        if (typeof BaseUrl === 'function') {
            return BaseUrl()
        }

        return BaseUrl
    }

    return {
        content,
        config,
        baseUrl,
        headers,
        errored,
        getAppType,
    }
})()

export default Connection
